function tp_slide() {
  const slideMains = document.querySelectorAll(".js-slide-main");
  if (slideMains.length > 0) {
    slideMains.forEach(function (slideMain) {
      const loopSlide = JSON.parse(slideMain.getAttribute("data-loop")),
        autoSlide = JSON.parse(slideMain.getAttribute("data-autoplay")),
        sectionId = slideMain.getAttribute("data-section-id");
      const onSliderChange = (selector) => {
        const items = slideMain.querySelectorAll(selector);

        // reset all items
        items.forEach(el => {
          el.classList.remove('is-visible');
        });

        // show items in active slide
        const activeItems = slideMain.querySelectorAll(
          '.swiper-slide-active ' + selector
        );

        activeItems.forEach(el => {
          if (!el.classList.contains('no-effect')) {
            requestAnimationFrame(() => {
              el.classList.add('is-visible');
            });
          }
        });
      };

      var slideStorepify = new Swiper(slideMain, {
        slidesPerView: 1,
        loop: loopSlide,
        autoplay: autoSlide,
        effect: 'fade',
        slideShadows: true,
        navigation: {
          nextEl: ".swiper-next-slider",
          prevEl: ".swiper-prev-slider",
        },

        pagination: {
          clickable: true,
          el: `.tp-swiper-pagination-${sectionId}`,
          renderBullet: function (index, className) {
            return `<span class="loading-spinner ${className}"><svg class="loading-spinner__circle-svg" viewBox="25 25 50 50"><circle class="loading-spinner__circle-stroke" cx="50" cy="50" r="20" fill="none" stroke-width="5" stroke-miterlimit="10"/></svg></span>`;
          },
        },
        on: {
          init() {
            onSliderChange('.tp-content__subtitle');
            onSliderChange('.tp-content__title');
            onSliderChange('.tp-content__description');
            onSliderChange('.tp-slide__box');
          },
          slideChangeTransitionEnd() {
            onSliderChange('.tp-content__subtitle');
            onSliderChange('.tp-content__title');
            onSliderChange('.tp-content__description');
            onSliderChange('.tp-slide__box');
          }
        }
      });
    })
  }
}
tp_slide();
document.addEventListener("shopify:section:load", tp_slide);
document.addEventListener("shopify:section:unload", tp_slide);